// extracted by mini-css-extract-plugin
module.exports = {"root":"BlockWithExtraContent_root__EpvXC","extra":"BlockWithExtraContent_extra__3jWD5"};